import { ComponentsOverrides, Theme } from '@mui/material';

export const StackStyles: ComponentsOverrides<Theme>['MuiStack'] = {
  root: {
    gap: '0.5rem',
  },
};